import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Collapse } from "reactstrap";

// icons
import IconSearch from "react-icons/lib/md/search";
import PdmReport from "react-icons/lib/fa/edit";
import PdmDataEntry from "react-icons/lib/fa/cloud-upload";
import ReportsIcon from "react-icons/lib/md/insert-chart";
import IconPDM from "react-icons/lib/md/extension";
import IconDown from "react-icons/lib/md/chevron-right";
import IataIcon from "react-icons/lib/md/landscape";
import HelpIcon from "react-icons/lib/md/help-outline";
import TicketSearch from "react-icons/lib/md/question-answer";
import FlightOperationIcon from "react-icons/lib/md/flight"
import PassengerIcon from "react-icons/lib/md/date-range"
const StaffMenuComponent = ({ handleClick, selected, handleOpen }) => {
  return (
    <ul className="list-unstyled mt-3 nav-list clearfix">
      <li
        onClick={handleClick.bind(this, 2)}
        className={selected === 2 ? "selected" : ""}
      >
        <NavLink exact to="/search" activeClassName="active">
          <IconSearch size="20" color="#43a8df" />
          <span className="name">
            Manifest
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 8)}
        className={selected === 8 ? "selected" : ""}
      >
        <NavLink to="/reports" activeClassName="active">
          <ReportsIcon
            size="18"
            color="#43a8df"
            className="icon-insert-chart"
          />
          <span className="name">Reports</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 7)}
        className={selected === 7 ? "selected" : ""}
      >
        <NavLink to="/iata" activeClassName="active">
          <IataIcon size="18" className="icon-flight-takeoff" />
          <span className="name">Iata Report</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 50)}
        className={selected === 50 ? "selected" : ""}
      >
        <Link to="#">
          <IconPDM size="18" />
          <span className="name">PDM</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 50} onClick={handleOpen.bind(this, 50)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/pdm-report" activeClassName="active">
                <PdmReport size="18" className="FaEdit" />
                <span className="name">Report</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/pdm-data-entry" activeClassName="active">
                <PdmDataEntry size="18" className="icon-FaCloudUpload" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 60)}
        className={selected === 60 ? "selected" : ""}
      >
        <NavLink to="/billed-per-airport" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Billed per <br /> Airport
          </span>
        </NavLink>
      </li>
      <NavLink to="/ticket-search" activeClassName="active">
        <TicketSearch size="18" />
        <span className="name">
          Search By
          <br /> Ticket
        </span>
      </NavLink>
      <li>
        <NavLink to="/flight-operations" activeClassName="active">
          <FlightOperationIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Flight <br /> Operations
          </span>
        </NavLink>
      </li>
      <li
      >
        <NavLink to="/passenger-level-data" activeClassName="active">
          <PassengerIcon size="18" className="icon-insert-chart" />
          <span className="name">
           Passenger level <br /> Data
          </span>
        </NavLink>
      </li>
      <hr></hr>

      <li
        onClick={handleClick.bind(this, 68)}
        className={selected === 68 ? "selected" : ""}
      >
        <NavLink to="/help-center" activeClassName="active">
          <HelpIcon size="18" className="icon-insert-chart" />
          <span className="name">Help Center</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default StaffMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/components/nav/menu/staff.js